import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../_services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                const reqData = {
                    "SignOut": {
                        "LoginSessionKey": this.authenticationService.currentUserValue.LoginSessionKey
                    }
                };
                this.authenticationService.logout(reqData);
                location.reload();
            }

            if (err.status === 403) {
                // auto logout if 403 response returned from api
                // const reqData = {
                //     "SignOut": {
                //         "LoginSessionKey": this.authenticationService.currentUserValue.LoginSessionKey
                //     }
                // };
                // this.authenticationService.logout(reqData);
                localStorage.clear();
                location.reload();

            }

            const error = err.error.message || err.statusText;
            return throwError(error);
        }))
    }
}